<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Dados de Processamento - Enquadramento Legal"
    [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">
    <p class="po-font-subtitle">Verfique todos os Enquadramentos Legais incluidos no sistema.
    </p>
    <po-divider></po-divider>
    <div class="po-row po-mb-4 shadow">
        <div>
            <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
        </div>
        <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true" [p-spacing]="poTableColumnSpacing"
            [p-loading-show-more]="!isHideLoading"
            p-container="border" p-hide-columns-manager="false" [p-columns]="columns" [p-items]="this.tableItens">
            <ng-template p-table-column-template [p-property]="'obs'" let-value>
                <span [innerText]="value" class="po-font-text-large-bold"></span>
            </ng-template>
            <ng-template p-table-column-template [p-property]="'id'" let-value>
                <span [innerText]="value" class="po-font-text-large-bold"></span>
            </ng-template>
        </po-table>
    </div>
</po-page-list>
